//This helper only exists so the users can record audio on Safari and IE. It is imported to AudioRecorderHooks.ts.
import AudioRecorder from 'audio-recorder-polyfill';
export const audioRecorderHelper = window.MediaRecorder = AudioRecorder;